<template>
  <header>
    <slot v-if="!!$slots['title']" name="title" />
    <h1 v-else>{{ title }}</h1>

    <slot v-if="!!$slots['default']" name="default" />
    <div v-else class="buttons">
      <template v-for="(action, key) in currentActions">
        <router-link
          class="button is-rounded"
          v-bind:class="{
            [action.class]: action.class,
          }"
          :disabled="action.disabled"
          :to="action.route"
          :key="key"
          v-if="$can(action.route)"
        >
          {{ action.label }}
        </router-link>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: String,
    actions: Array,
  },
  data() {
    return {
      currentActions: [],
    };
  },
  watch: {
    actions: {
      immediate: true,
      handler(newActions) {
        this.currentActions = newActions;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

h1 {
  font-size: 28px;
}

.button[disabled="disabled"] {
  pointer-events: none;
  opacity: 0.6;
  user-select: none;
}
</style>
